import React from "react";

const OpaySetting = () => {
  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-4">Opay Setting</h1>
      <p className="text-sm text-gray-700">
        Configure Opay gateway options here. Add credentials, toggle status,
        and manage channels.
      </p>
    </div>
  );
};

export default OpaySetting;
